module.exports = __webpack_public_path__ + "static/media/secure.a78bf711.png";